// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1quo7","modalForm":"UpgradeEpcsModal_modalForm__jxLrF","modalFooter":"UpgradeEpcsModal_modalFooter__27NT7"};